export default "__VITE_ASSET__wOMnsrSI__"